module.exports = __webpack_public_path__ + "media/checkmarks/transparent-checkmark-green-bg-9b40c3c9.svg";